<template>
    <div v-if="isUserAuthenticated()">
        <v-dialog :value="value" @input="$emit('input', $event)" max-width="1200px">
            <!-- <v-btn slot="activator" color="primary" dark class="mb-2" @click="createItem()">Nouveau contrat</v-btn> -->
            <v-card>
            <v-card-title>
                <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text style="padding-top:0px;padding-bottom:0px;">
                <v-form v-model="valid" ref="form" lazy-validation>
                  <v-container grid-list-md>
                    <v-layout wrap>
                        <!--
                            ContractId:{{ID}}
                        -->
                        <v-flex xs12 sm12 md12>
                          <v-text-field v-model="this.CustomerName" label="Nom à facturer" disabled hide-details></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field v-model="this.AddressSnowRemovalFullAddress" label="Adresse de déneigement" disabled hide-details></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-combobox
                              :items="transmissiontypeitems"
                              v-model="editedItem.TransmissionType"
                              item-text="Name"
                              item-value="ID"
                              label="Envoi contrat"
                              hide-details
                              :rules="requiredRules"
                              required
                          ></v-combobox>
                        </v-flex>
                        <v-flex xs4 sm4 md4>
                          <!-- :rules="requiredRules" required -->
                          <v-text-field v-model="editedItem.Price" label="Prix" @change="recalculateTaxes(editedItem)" hide-details></v-text-field>
                        </v-flex>
                        <v-flex xs4 sm4 md4>
                          <v-text-field v-model="editedItem.TPS" label="TPS" hide-details></v-text-field>
                        </v-flex>
                        <v-flex xs4 sm4 md4>
                          <v-text-field v-model="editedItem.TVQ" label="TVQ" hide-details></v-text-field>
                        </v-flex>
                        <v-flex xs3 sm3 md3>
                          <v-checkbox v-model="editedItem.IsPoleInstalled" label="Poteau" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex xs3 sm3 md3>
                          <v-checkbox v-model="editedItem.IsRenew" label="Renouveler" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex xs3 sm3 md3>
                          <v-checkbox v-model="editedItem.IsReceived" label="Reçu" hide-details></v-checkbox>
                        </v-flex>
                        <v-flex xs3 sm3 md3>
                          <v-checkbox v-model="editedItem.IsActive" label="Est actif" hide-details></v-checkbox>
                        </v-flex>
                        <!-- <v-flex xs6 sm6 md6>
                        <v-combobox
                            :items="paymentmethodtypeitems"
                            v-model="editedItem.Customer"
                            item-text="Name"
                            item-value="ID"
                            label="Méthode de paiement"
                        ></v-combobox>
                        </v-flex> -->
                        <v-flex xs12 sm12 md12 v-if="editedItem.ID > 0">
                        <!-- <SimpleListComponent></SimpleListComponent> -->
                        <!-- :contractId=item.ID -->
                        <!-- ID:{{editedItem.ID}} -->
                        <GridPayment :contractId="editedItem.ID"></GridPayment>
                        </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="blue darken-1" flat @click.native="sendInvoice()">Envoyer facture par courriel</v-btn>
                <v-btn color="blue darken-1" flat @click.native="printInvoice(editedItem)">Imprimer facture</v-btn>
                <v-btn color="blue darken-1" flat @click.native="close">Annuler</v-btn>
                <v-btn color="blue darken-1" flat @click.native="save">Sauvegarder</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
          v-model="snackbar.show"
          :color="snackbar.color"
          :timeout="snackbar.timeout"
          :top="snackbar.top"
          :right="snackbar.right"
        >
          {{snackbar.text}}
        </v-snackbar>
        <ModalConfirmation v-model="dialogEmailConfirmation" :Title="dialogEmailTitle" :Message="dialogEmailMessage" :CallBackYes="dialogEmailCallBackYes"></ModalConfirmation>
    </div>
</template>

<script>
import auth from '@/auth'
//import SimpleListComponent from '@/components/SimpleList.vue'
import GridPayment from '@/components/GridPayment.vue'
import TemplateAdminComponent from '@/components/TemplateAdmin.vue'
import ModalConfirmation from '@/components/ModalConfirmation.vue'
import TaxCalculator from '@/components/TaxCalculator'
import APIInvoice from '@/api/invoice'
import APIReport from '@/api/report'
import APIContract from '@/api/contract'
import APITransmissionType from '@/api/transmissiontype'
import APICustomer from '@/api/customer'
const APIService = new APIContract();
const APITransmissionTypeService = new APITransmissionType();
const APICustomerService = new APICustomer();
const APIReportService = new APIReport();
const APIInvoiceService = new APIInvoice();
const TaxCalculatorService = new TaxCalculator();

var axios = require('axios')

export default {
   props: {
    ID: { type: Number, required: true },
    CustomerID : {type: Number, required: true},
    CustomerName: {type: String, required: true },
    AddressSnowRemovalFullAddress: {type: String, required: true },
    value: { type: Boolean, required: true },
    CallBackSave: { type: Function, required: true }
  },
  components:
  {
    TemplateAdminComponent,
    ModalConfirmation,
    GridPayment
  },

  mounted() {
    //alert("mounted")
    this.$refs.form.resetValidation()
    //$('#date').datepicker()
    //$('#date').hide();
    //this.initialize()
    //debugger;
  },

  data() {
    //debugger;
    return {
        loading: false,
        search: '',

        dialogEmailConfirmation: false,
        dialogEmailTitle: "Envoi de courriel",
        dialogEmailMessage: "",

        messageConfirmation: "Êtes-vous sûr de vouloir envoyer un courriel à {EMAIL} ?",
        messageConfirmed: "Le courriel a été envoyé avec succes à {EMAIL}",

        snackbar: {
          show: false,
          timeout: 5000,
          color: 'success',
          text: '',
          templatetext: '',
          top: true,
          right: true
        },

        pagination: {
          sortBy: 'Name',
          page: 1,
          rowsPerPage: 10
        },
        headers : [
          { text: 'Période', value: 'Period.Name', align: 'left' },
          { text: 'Secteur', value: 'Customer.AddressSnowRemoval.Street.Sector', align: 'left' },
          { text: 'Appartement', value: 'Customer.AddressSnowRemoval.AptNumber', align: 'left' },
          { text: 'Adresse à déneiger', value: 'Customer.AddressSnowRemoval.FullAddress', align: 'left' },
          { text: 'Nom à facturer', value: 'BillToName', align: 'left' },
          { text: 'Numéro de client', value: 'Customer.AddressSnowRemoval.AddressCustomerNumber', align: 'left' },
          { text: 'Actions', value: 'Actions', align: 'center', sortable: false }
        ],
        valid: false,
        requiredRules: [
          (v) => !!v || 'Field is required.',
        ],
        //items: [],
        transmissiontypeitems: [],
        paymentmethodtypeitems: [],
        editedItem: {},
        defaultItem: {
          TransmissionType: null,
          PaymentMethodType: null,
          TPS: 0.00,
          TVQ: 0.00,
          IsActive: true
        }
    }
  },

  computed: {
    formTitle () {
      //return this.props["contract"].ID <= 0 ? 'Nouveau contrat' : 'Modification du contrat'
      //return this.contract.ID <= 0 ? 'Nouveau contrat' : 'Modification du contrat'
      return 'Modification du contrat'
    },

    pages () {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null)
        return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  },

  watch: {
    items () {
      this.$nextTick(() => {
        this.pagination.totalItems = this.items.length
      })
    },
    ID () {
      this.initialize()
    }
    // ID : {
    //   immediate: true,
    //   handler: function (val, oldVal) {
    //     debugger;
    //     this.initialize()
    //   }
    // }
  },

  created(){
    this.initialize()
    //alert("created")
  },

  methods: {
    isUserAuthenticated() {
      return auth.isUserAuthenticated()
    },

    logout() {
      auth.logout()
    },

    initialize () {
      if (this.ID > 0)
      {
        APIService.get(this.ID).then(response =>  {
            //this.items = response.data
            this.editedItem = response.data
          }
        )
      }
      else
      {
        this.editedItem = Object.assign({}, this.defaultItem)
      }

      APITransmissionTypeService.getAll().then(response =>  {
            this.transmissiontypeitems = response.data
        }
      )
    },

    changeSort (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },

    recalculateTaxes(item) {
      //debugger;
      var price = parseFloat(item.Price)

      //var test = process.TPSRATE
      item.TPS = TaxCalculatorService.calculateTPS(price)
      item.TVQ = TaxCalculatorService.calculateTVQ(price)
    },

    close () {
      this.$emit('input', false)
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      }, 300)
    },

    sendInvoice () {
      this.dialogEmailMessage = this.messageConfirmation.replace("{EMAIL}", this.editedItem.Customer.Email)
      this.dialogEmailConfirmation = true
    },

    dialogEmailCallBackYes() {
      this.dialogEmailConfirmation = false
      APIInvoiceService.sendInvoiceByEmail(this.ID).then(response => {
        this.snackbar.text = this.messageConfirmed.replace("{EMAIL}", this.editedItem.Customer.Email)
        this.snackbar.show = true
      })
    },

    async printInvoice (item) {
      this.$router.open({name: 'AdminInvoice', params: {ID : item.ID}})
    },

    save () {
      //debugger
      //if (this.$refs.form.validate()) {
        if (this.editedItem.ID > 0) {
          //UPDATE
          APIService.update(this.editedItem).then(response => {
            this.$refs.form.resetValidation()
            this.close()
          })
        } else {
          //CREATE
          this.editedItem.CustomerID = this.CustomerID
          APIService.create(this.editedItem).then(response => {
            this.editedItem = response.data
            this.CallBackSave(this.editedItem)
            this.$refs.form.resetValidation()
            //this.close()
          })
        }
      //}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ModalContract.vue